module.exports = __webpack_public_path__ + "static/media/contract.e42d0230.svg";